var $          = require('./$')
  , createDesc = require('./$.property-desc');
module.exports = require('./$.descriptors') ? function(object, key, value){
  return $.setDesc(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.hide.js
// module id = vFvP
// module chunks = 0